/**
 * Digitization Page
 *
 * Staff workflow page for managing orders in digitization stages.
 */

import WorkflowPage from './WorkflowPage';
import type { WorkflowStage } from '../types';

const DIGITIZATION_STAGES: WorkflowStage[] = [
  'DIGITIZED_MOLD_SENT',
  'DIGITIZED_MOLD_RECEIVED',
];

export default function Digitization() {
  return (
    <WorkflowPage
      title="Digitization"
      stages={DIGITIZATION_STAGES}
      defaultStage="DIGITIZED_MOLD_SENT"
      emptyMessage="No orders waiting for digitization"
    />
  );
}
